module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Desktop_22.1b587a24.jpg";